import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#3d4f5f]" data-testid="footer">
      {/* Main Footer Content */}
      <div className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12 items-start">
            {/* Logo & Address */}
            <div className="text-center md:text-left">
              <img
                src="https://customer-assets.emergentagent.com/job_finance-portal-143/artifacts/syg2bhjq_summit-investment-group-2-279w%20%281%29.webp"
                alt="Summit Investment Group"
                className="h-14 w-auto mb-6 mx-auto md:mx-0 brightness-0 invert"
              />
              <p className="text-gray-300 text-sm">
                10505 S. 68th E Ave
                <br />
                Tulsa, OK 74133
              </p>
            </div>

            {/* Menu */}
            <div className="text-center">
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Menu</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/retirement-planning" className="text-gray-300 hover:text-white transition-colors">
                    Retirement Planning
                  </Link>
                </li>
                <li>
                  <Link to="/wealth-management" className="text-gray-300 hover:text-white transition-colors">
                    Wealth Management
                  </Link>
                </li>
                <li>
                  <Link to="/financial-advisor" className="text-gray-300 hover:text-white transition-colors">
                    Financial Advisor
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Get In Touch */}
            <div className="text-center md:text-right">
              <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Get In Touch</h4>
              <p className="text-gray-300 text-sm mb-2">
                <a href="tel:+19184777227" className="hover:text-white transition-colors">
                  918.477.7227
                </a>
              </p>
              <p className="text-gray-300 text-sm">
                <a href="mailto:curt@summitinvesting.com" className="hover:text-white transition-colors">
                  curt@summitinvesting.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div className="border-t border-gray-500/30 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto text-xs text-gray-400 space-y-4 text-center">
          <p>
            Investment advisory services are provided in accordance with a fiduciary duty of care and loyalty that
            includes putting your interests first and disclosing conflicts. Insurance services have a best interest
            standard which requires recommendations to be in your best interest. Advisors may receive commission for the
            sale of insurance and annuity products.
          </p>
          <p>
            Investment advisory services offered through CreativeOne Wealth, LLC a Registered Investment Adviser.
            CreativeOne Wealth, LLC and Summit Investment Group, LLC are unaffiliated entities. Licensed Insurance
            Professional.
          </p>
          <p>
            Licensed Insurance Professional. We are an independent financial services firm helping individuals create
            retirement strategies using a variety of investment and insurance products to custom suit their needs and
            objectives. This material has been prepared for informational and educational purposes only. It is not
            intended to provide, and should not be relied upon for, accounting, legal, tax or investment advice.
          </p>
          <p>
            Investing involves risk, including the loss of principal. No investment strategy can guarantee a profit or
            protect against loss. Any references to protection benefits or lifetime income generally refer to fixed
            insurance products, never securities or investment products. Insurance and annuity products are backed by
            the financial strength and claims-paying ability of the issuing insurance company.
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-500/30 py-4 px-4 text-center">
        <div className="max-w-5xl flex flex-col-reverse gap-3 md:flex-row justify-between items-center mx-auto">
          <p className="text-xs text-gray-400">
            © 2000-{new Date().getFullYear()} Summit Investment Group. All rights reserved.
          </p>
          <div className="flex gap-4 items-center justify-end">
            <Link
              to="https://info.creativeone.com/hubfs/Wealth%20Forms/CreativeOne_Wealth_Privacy_Notice.pdf"
              target="_blank"
              className="text-xs text-gray-400 underline underline-offset-2"
            >
              CreativeOne Wealth Privacy Notice
            </Link>
            <Link
              to="https://43700266.fs1.hubspotusercontent-na1.net/hubfs/43700266/Wealth%20Forms/Form_ADV_Part_2A.pdf"
              target="_blank"
              className="text-xs text-gray-400 underline underline-offset-2"
            >
              ADV 2A Form
            </Link>
            <Link
              to="https://43700266.fs1.hubspotusercontent-na1.net/hubfs/43700266/Wealth%20Forms/Form_CRS.pdf"
              target="_blank"
              className="text-xs text-gray-400 underline underline-offset-2"
            >
              CRS Form
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
